export const SET_IMAGE_SEARCH_DATA = 'SET_IMAGE_SEARCH_DATA';
export const CLEAR_IMAGE_SEARCH_DATA = 'CLEAR_IMAGE_SEARCH_DATA';
export const SET_IMAGE_SEARCH_FETCHING = 'SET_IMAGE_SEARCH_FETCHING';
export const SET_IMAGE_SEARCH_ERROR = 'SET_IMAGE_SEARCH_ERROR';

export const setImageSearchData = (data: any) => ({
  type: SET_IMAGE_SEARCH_DATA,
  payload: data,
});

export const clearImageSearchData = () => ({
  type: CLEAR_IMAGE_SEARCH_DATA,
});

export const setImageSearchFetching = (isFetching: boolean) => ({
  type: SET_IMAGE_SEARCH_FETCHING,
  payload: isFetching,
});

export const setImageSearchError = (error: any) => ({
  type: SET_IMAGE_SEARCH_ERROR,
  payload: error,
});
